module.exports = __webpack_public_path__ + "img/t5-4.8dba96ed.svg";